import { createFeatureSelector } from '@ngrx/store';

import { User } from '®shared/auth';
import {
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';
import { ListItem } from '®shared/reading-list';

import { BrokenLinkReport } from './broken-link-report';

export const STATE_FEATURE_REPORT_BROKEN_LINK = 'reportBrokenLink';

export interface ReportBrokenLinkState {
  brokenLinkReport: BrokenLinkReport | null;
  currentItem: ListItem | null;
  modalControl: ModalControlsSaveable;
  user: User | null;
}

export const REPORT_BROKEN_LINK_INITIAL_STATE: ReportBrokenLinkState = {
  brokenLinkReport: null,
  currentItem: null,
  modalControl: ModalControlsSaveableFactory.hide(),
  user: null,
};

export function getInitialReportBrokenLinkState(): ReportBrokenLinkState {
  return REPORT_BROKEN_LINK_INITIAL_STATE;
}

export const selectReportBrokenLinkState =
  createFeatureSelector<ReportBrokenLinkState>(
    STATE_FEATURE_REPORT_BROKEN_LINK,
  );
